module.exports = __webpack_public_path__ + "img/01.ce5ff955.svg";